export default __webpack_public_path__ + "KaTeX_Script-Regular.cd3b0634cbb3864a6105cbc61511f48c.woff";